let bookMap = {
    el:{
        canvas: null,
        container: document.getElementById('map-holder'),
        panel: {
            info: {
                holder: document.getElementById('map-panel-bottom-left'),
                title: document.getElementById('map-panel-bottom-left-title'),
                info: document.getElementById('map-panel-bottom-left-info'),
                btn: document.getElementById('map-panel-bottom-left-btn'),
            }
        },
        btn:{
            zoomPlus: document.getElementById('js-zoom-plus-btn'),
            zoomReset: document.getElementById('js-zoom-reset-btn'),
            zoomMin: document.getElementById('js-zoom-min-btn'),
        }
    },
    state:{
        init: false,
        mapId: null,
        mapTypeId: null,
        selectedItem: {
            has: false,
            title: 'Loading',
            info: '',
            onclick: null,
        }
    },
    setting:{
        zoomMinLimit: 0.1,
        zoomMaxLimit: 2,
        zoomStep: 0.1,
    },
    init(mapId, mapTypeId){
        let doInit = !this.state.init || this.state.mapTypeId !== mapTypeId;
        if(doInit) {
            this.state.mapId = mapId;
            this.state.mapTypeId = mapTypeId;
            this.el.canvas = new fabric.Canvas('js-canvas', {
                selection: false,
            })
            this.setEventListeners();
        }
        this.resizeCanvas();
        if(doInit) {
            this.renderState();
        }

        this.state.init = true;
        this.render();
    },
    openMap(mapId, mapTypeId){
        this.state.mapId = mapId;
        this.state.mapTypeId = mapTypeId;
        this.renderState();
    },
    setEventListeners() {
        window.addEventListener('resize', this.resizeCanvas.bind(this));
        this.el.btn.zoomPlus.addEventListener('click', this.addZoom.bind(this, .1));
        this.el.btn.zoomReset.addEventListener('click', this.setZoom.bind(this, 1));
        this.el.btn.zoomMin.addEventListener('click', this.addZoom.bind(this, -.1));
        this.setZoomForPc();
        this.setMouseActions();
        this.setKeyControl();
    },

    setKeyControl() {
        document.addEventListener("keydown", function (ev) {
            if(ev.target && ev.target.nodeName === "INPUT"){ // Skip input
                return;
            }

            // Zoom action
            if (ev.key === '0') {
                this.setZoom(1);
            }
            if (ev.key === '-') {
                this.addZoom(-1 * this.setting.zoomStep);
            }
            if (ev.key === '=') {
                this.addZoom(this.setting.zoomStep);
            }

            // Move
            let step = 50;
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                this.moveMap(0, -step, true);
            }
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                this.moveMap(0, step, true);
            }
            if (ev.key === 'ArrowLeft') {
                ev.preventDefault();
                this.moveMap(step, 0, true);
            }
            if (ev.key === 'ArrowRight') {
                ev.preventDefault();
                this.moveMap(-step, 0, true);
            }
        }.bind(this));
    },
    setZoomForPc(){
        this.el.canvas.on('mouse:wheel', function(opt) {
            let c = this.el.canvas;
            let delta = (opt.e.deltaY > 0 ? -1 : 1); // Always in steps
            let zoom = this.checkZoomValue(c.getZoom() + (delta / 100));
            c.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
            this.updateZoomLevelOnButton();
            opt.e.preventDefault();
            opt.e.stopPropagation();
        }.bind(this));
    },
    hasTwoTouchPoints: function(opt){
        return (opt.e && opt.e.touches && opt.e.touches.length === 2)
    },
    checkZoomValue: function(zoom){
        if (zoom > this.setting.zoomMaxLimit) zoom = this.setting.zoomMaxLimit;
        if (zoom < this.setting.zoomMinLimit) zoom = this.setting.zoomMinLimit;
        return zoom;
    },

    // Navigation functions
    setZoom(level) {
        this.el.canvas.setZoom(level);
        this.updateZoomLevelOnButton();
    },
    addZoom(level) {
        let c = this.el.canvas;
        level = this.checkZoomValue(c.getZoom() + level);
        c.zoomToPoint(new fabric.Point(c.getWidth() / 2, c.getHeight() / 2), level);
        this.updateZoomLevelOnButton();
    },
    moveMap(x, y, isRelative) {
        let p = new fabric.Point(x, y);
        if (isRelative) {
            this.el.canvas.relativePan(p);
        } else {
            this.el.canvas.absolutePan(p);
        }
    },

    setMouseActions(){
        let m = this;
        let c = m.el.canvas;
        let previousTouchZoomValue = undefined;

        c.on('mouse:down', function(opt) {
            if(this.hasTwoTouchPoints(opt)){
                return;
            }
            if(opt.target){
                opt.target.changeColor("#111", false);
            }

            this.isDragging = true;
            this.lastPosX = parseInt(opt.pointer.x);
            this.lastPosY = parseInt(opt.pointer.y);
        }.bind(this));
        c.on('mouse:move', function(opt) {
            if(this.hasTwoTouchPoints(opt)){
                let p1 = opt.e.touches[0];
                let p2 = opt.e.touches[1];
                let delta = Math.abs(p1.clientX - p2.clientX) + Math.abs(p1.clientY - p2.clientY);
                let step = 0.02 * (previousTouchZoomValue && previousTouchZoomValue > delta ? 1 : -1);

                this.addZoom(-step);
                previousTouchZoomValue = delta;
                return;
            }
            if (this.isDragging) {
                let x = parseInt(opt.pointer.x)
                let y = parseInt(opt.pointer.y)
                let p = new fabric.Point(x - this.lastPosX, y - this.lastPosY);
                this.el.canvas.relativePan(p)
                this.lastPosX = x;
                this.lastPosY = y;
            }
        }.bind(this));
        c.on('mouse:up', function(opt) {
            this.state.selectedItem.has = false;
            if(opt.target){
                if(opt.target.placeId){
                    // Find info
                    let placeInfo = this.state.placeInfo[opt.target.placeId];
                    if(placeInfo && (placeInfo.status === 'available' || placeInfo.status === 'soon-available')){
                        this.state.selectedItem.has = true;
                        this.state.selectedItem.title = placeInfo.name;
                        this.state.selectedItem.info = placeInfo.r_info;
                        this.state.selectedItem.onclick =  function (){
                            bookView.onUsePlace(opt.target.placeId, placeInfo.available_after);
                            this.state.selectedItem.has = false;
                            this.renderPanelInfo();
                        }.bind(this);
                    }
                }
                this.updatePlaceStatus();
            }
            this.isDragging = false;
            this.renderPanelInfo();
        }.bind(this));
    },

    renderState(){
        this.resetMap();
        this.setElementFromDatabase();
        this.updatePlaceStatus();
        // this.setPlaceSelectorItems();
        this.updateZoomLevelOnButton();
    },
    resetMap(){
        this.el.canvas.clear();
    },
    setElementFromDatabase(){
        // Request data
        let data = requestHelper.getJson('/api/book/map/' + this.state.mapId + '/' + this.state.mapTypeId);
        if(data.background){
            this.state.background = data.background;
            this.setBackgroundImage();
        }
        if(data.zoom){
            this.setZoom(parseFloat(data.zoom));
        }
        if(data.start_position_x && data.start_position_x){
            this.moveMap(data.start_position_x, data.start_position_y)
        }

        if(data.point_1 && data.point_1.length != 0) {
            this.jsonToElements(data.point_1);
        }
        if(data.place_info){
            this.state.placeInfo = data.place_info;
        }
    },
    jsonToElements: function (json) {
        let elements = JSON.parse(json);
        for(let i = 0; i < elements.length; i++){
            let e = elements[i];
            if(e.doorId){continue;}
            this.el.canvas.add(
                this.rectLabel(e.x,e.y,e.w,e.h,e.a, 'gray', undefined, e.placeId)
            );
        }
    },

    rectLabel: function (x, y, w, h, a, color, textStr, placeId) {
        textStr = textStr ? textStr : '-';
        let rect = new fabric.Rect({
            fill: color,
            width : w - 1, // -1 fis random move
            height : h - 1, // -1 fix random move
            left: 0,
            top: 0,
            stroke : 'black',
            strokeWidth : 2
        });
        let text = new fabric.Textbox(textStr, {
            fontSize: 40,
            left: 10,
            top: 10,
            fill: '#FFF',
            width: w - 14,
        });
        let textUnder = new fabric.Textbox("", {
            fontSize: 20,
            left: 10,
            top: 10,
            fill: '#FFF',
            width: w - 14,
        });
        let statusDoor = new fabric.Rect({
            top: 0, left: w - 20, width: 20, height: 60,
            fill: 'transparent'}
        );
        let group = new fabric.Group([ rect, statusDoor, text, textUnder,  ], {
            left: x,
            top: y,
            angle: a ? a : 0,
        });
        this.setElementDefaultStyle(group);

        // Fix text scaling
        group.isChanged = false;
        group.on('scaling', function() {
            text.set('left', 10 - ((group.width / 2)));
            text.set('top', 10 - ((group.height / 2)));
            text.set('scaleX', group.width / (group.width * group.scaleX));
            text.set('scaleY', group.height / (group.height * group.scaleY));
            group.isChanged = true;
        });

        // Update func
        group.changeColor = function (color, absent, doorState){
            statusDoor.set('fill', 'transparent');
            if(absent){
                let col2 = '#ababab';
                let bg = new fabric.Gradient({
                    type: "linear",
                    gradientUnits: "percentage",
                    coords: { x1: 0, y1: 0, x2: 1, y2: 0 },
                    colorStops: [
                        { offset: 0, color: color },

                        { offset: .20, color: color },
                        { offset: .21, color: col2 },
                        { offset: .39, color: col2 },
                        { offset: .40, color: color },

                        { offset: .60, color: color },
                        { offset: .61, color: col2 },
                        { offset: .79, color: col2 },
                        { offset: .80, color: color },
                    ],
                });
                rect.set('fill', bg);
            }
            else {
                rect.set('fill', color);
            }
        }
        group.changeText = function(txt, underline){
            text.set('text', txt);
            let decMargin = 28;
            let minFontSize = 14;
            let normalFontSize = 44;
            if((text.width + decMargin > rect.width) || (text.height + decMargin > rect.height)){
                let textWidthMa = text.width + decMargin;
                let textHeightMa = text.height + decMargin;
                let widthScale = textWidthMa > rect.width ? rect.width * 100 / textWidthMa / 100 : 1;
                let widthFontSize = widthScale < 1 ? Math.max(normalFontSize * widthScale, minFontSize) : normalFontSize;
                let heightScale = textHeightMa > rect.height ? rect.height * 100 / textHeightMa / 100 : 1;
                let heightFontSize = heightScale < 1 ? Math.max(normalFontSize * heightScale, minFontSize) : normalFontSize;
                text.fontSize = Math.min(widthFontSize, heightFontSize);;
                text.width= w - 14;
            }
            if(underline && text.width > 100 && (group.height - text.height > 50)){
                let underlineSmall = underline.substring(0, 20) + (underline.length > 20 ? '..':'');
                textUnder.set('text', underlineSmall)
                textUnder.top = 1;
            }
        }
        group.makeEmptyStyle = function (){
            group.changeText('-', '');
            group.changeColor('gray', false, null);
            group.opacity = 0.6;
        }

        // Set items
        group.elementType = 'rectLabel';
        group.placeId = placeId;
        return group;
    },
    setElementDefaultStyle: function(element){
        element.set({
            padding: 9,
            cornerSize: 18,
            transparentCorners: false,
            hoverCursor: "pointer",
            hasControls: false,
            lockMovementX: true,
            lockMovementY: true,
            hasBorders: false,
        });
        element.lockScalingFlip = true;
    },
    updatePlaceStatus: function(){
        let statusToColor = {
            '': 'gray',
            'unavailable': 'gray',
            'available': '#00a699',
            'soon-available': '#006aa6',
        };

        // Loop there items
        let elements = this.el.canvas.getObjects();
        for (let i = 0; i < elements.length; i++) {
            let element = elements[i];
            let placeId = element.placeId;
            let placeInfo = placeId && this.state.placeInfo && this.state.placeInfo[placeId]
                ? this.state.placeInfo[placeId]
                : undefined;
            if(placeInfo){
                let after = placeInfo.available_after
                    ? '\n Na ' + inputDateForState.dateToNl(placeInfo.available_after) : '';
                element.changeText(placeInfo.name + after, placeInfo.underline);
                if(statusToColor[placeInfo.status]){
                    element.changeColor(statusToColor[placeInfo.status], (placeInfo.absent ? true : false), placeInfo.d_s);
                }
            }
            else {
                element.makeEmptyStyle();
            }
        }
    },
    updateZoomLevelOnButton: function () {
        let zoomLevel = parseInt( 100 * this.el.canvas.getZoom() );
        let btn = this.el.btn.zoomReset;
        btn.innerHTML = zoomLevel + '%';
    },
    setBackgroundImage(){
        this.el.canvas.setBackgroundImage(this.state.background, this.el.canvas.renderAll.bind(this.el.canvas));
    },
    resizeCanvas() {
        this.el.canvas.setWidth(this.el.container.clientWidth);
        this.el.canvas.setHeight(this.el.container.clientHeight);
        this.el.canvas.calcOffset();
        this.el.canvas.requestRenderAll();
    },
    // Render
    render(){
        this.renderPanelInfo();
    },
    renderPanelInfo(){
        panel.set(this.el.panel.info.holder, this.state.selectedItem.has);
        if(!this.state.selectedItem.has){return;}
        this.el.panel.info.title.innerHTML = this.state.selectedItem.title;
        this.el.panel.info.info.innerHTML = this.state.selectedItem.info;
        this.el.panel.info.btn.onclick = this.state.selectedItem.onclick;
    }
}